Ext.define('SA.view.ManageImportsWindow', {
    alias: 'widget.manage-imports-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-manage-imports-window',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-manage-imports-window-header',
            itemId: 'header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-manage-imports-window-header-title',
                    html: 'Manage Imported Data'
                }, {
                    xtype: 'close-button',
                    closeAction: 'onCloseBtnClick'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-manage-imports-window-body',
            itemId: 'body',

            tpl: [
                '<table class="sa-imports-table">',
                    '<tr><td>Import Date</td><td>Dataset Name</td></tr>',
                    '<tpl for=".">',
                        '<tr data-dataset-id="{id}">',
                            '<td class="sa-imports-table-import-date-cell">{imported:date("M j, Y")}</td>',
                            '<td>',
                                '<span class="sa-imports-table-dataset-name">{name:htmlEncode}</span> ',
                                '<span class="sa-imports-table-dataset-units">({units})</span>',
                            '</td>',
                            '<td>',
                                '<a class="sa-imports-table-link" data-link-type="editName" href="#">Edit name</a>',
                                '<a class="sa-imports-table-link" data-link-type="delete" href="#">Delete</a>',
                            '</td>',
                        '</tr>',
                    '</tpl>',
                '</table>'
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.header = this.down('#header');
        this.body = this.down('#body');

        this.body.update(this.getTplData());
    },

    beforeDestroy() {
        this.callParent();

        SA.Viewport.un('resize', this.refreshBodyHeight, this);
    },

    getNameElForDatasetId(datasetId) {
        return this.getRowElForDatasetId(datasetId).querySelector('.sa-imports-table-dataset-name');
    },

    getRowElForDatasetId(datasetId) {
        var rows = Array.from(this.el.dom.querySelectorAll('tr'));

        return rows.find(row => row.getAttribute('data-dataset-id') === datasetId);
    },

    getTplData() {
        var datasets = SA.data.UserDatasets.getAll(),
            sortNewestFirst = (a, b) => b.imported - a.imported;

        return datasets.map(mapDataset).sort(sortNewestFirst);

        function mapDataset(dataset) {
            var imported = new Date(dataset.imported * 1000),
                units = SA.data.GeographicUnits.get(dataset.geographicUnits).map(({name}) => name).join(', ');

            return Object.assign({}, dataset, {imported, units});
        }
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onRowLinkClick, this, {delegate: 'a'});

        SA.Viewport.on('resize', this.refreshBodyHeight, this);
    },

    onBoxReady() {
        this.callParent(arguments);

        this.refreshBodyHeight();
    },

    onCloseBtnClick() {
        this.fireEvent('click:closeBtn');
    },

    onRowLinkClick(ev, el) {
        var linkType = el.getAttribute('data-link-type'),
            datasetId = Ext.fly(el).parent('tr').getAttribute('data-dataset-id');

        ev.preventDefault();

        this.fireEvent(`click:${linkType}`, datasetId);
    },

    refreshBodyHeight() {
        var viewportHeight = Ext.Element.getViewportHeight(),
            headerHeight = this.header.getHeight(),
            availableHeight = viewportHeight - headerHeight - 20 - 2, 
            getConstrainedHeight = () => Math.min(availableHeight, this.body.getHeight());

        this.body.setHeight(null);
        this.body.setHeight(getConstrainedHeight());
    },

    removeDataset(datasetId) {
        var rowEl = this.getRowElForDatasetId(datasetId);

        Ext.fly(rowEl).remove();
    },

    updateName(datasetId, name) {
        var nameEl = this.getNameElForDatasetId(datasetId);

        nameEl.textContent = name;
    }
});